import moment from 'moment';
import { getCouleurCategorie, adressFullStringGetter } from '@/services/general/general';
import { CATEGORIE_DEFAULT } from '@/configurations/configPanneau';
import store from '@/store/store';

function getEcheanchier(tabPropriety, propriety, ech, echeanciers) {
  const dates = `${moment(ech.dateDebut).format('DDMMYYYY')}_${moment(
    ech.dateFin,
  ).format('DDMMYYYY')}`;
  const obj = {};
  tabPropriety.forEach((el) => {
    obj[el] = 0;
  });
  const echeancierLigne = {
    ...obj,
    dateDebut: ech.dateDebut,
    dateFin: ech.dateFin,
    [propriety]: ech.montant,
  };
  if (echeanciers[dates]) {
    tabPropriety.forEach((el) => {
      if (echeanciers[dates][el]) echeancierLigne[el] = echeanciers[dates][el];
    });
  }
  echeanciers[dates] = echeancierLigne;
}

export default function formatProduits(ligne) {
  let couleur = '';
  let categorie = '';
  let prixBrutProduit = 0;
  const echeanciers = {};
  const isNonRenouvelee = ligne.isNonRenouvelee === true;
  ligne.lignesCommande.forEach((ligneCommande) => {
    const echeancier = ligneCommande.echeanciers.find(
      (el) => el.referenceEcheancier === ligneCommande.referenceEcheancier,
    );
    if (echeancier === undefined) return;
    if (ligneCommande.produit && ligneCommande.produit.produitLocation) {
      const libelle = ligneCommande.libelle.replace('Location', '').trim();
      couleur = getCouleurCategorie(libelle);
      categorie = libelle || CATEGORIE_DEFAULT;
      // cette variable contiendra les dates de debut et de fin des echanciersLigne
      const dateLigne = echeancier.echeancierLignes.map((ech) => {
        let newDateFin = ech.dateFin;
        if (echeancier.quantitePeriodicite === 0) {
          newDateFin = ligneCommande.dateFin;
        }
        return {
          dateDebut: new Date(ech.dateDebut),
          dateFin: new Date(newDateFin),
        };
      });
      const minDateDebut = new Date(Math.min.apply(null, dateLigne.map((d) => d.dateDebut)));
      const maxDateFin = new Date(Math.max.apply(null, dateLigne.map((d) => d.dateFin)));
      if (echeancier) {
        const isEcheancierFictif = echeancier.id === '00000000-0000-0000-0000-000000000000';
        echeancier.isEcheancierFictif = isEcheancierFictif;
        echeancier.echeancierLignes.forEach((ech) => {
          const dates = `${moment(minDateDebut).format('DDMMYYYY')}_${moment(
            maxDateFin,
          ).format('DDMMYYYY')}`;
          prixBrutProduit = ligneCommande.prixUnitaire;
          const echeancierLigne = {
            dateDebut: minDateDebut,
            dateFin: maxDateFin,
            prixNet: ech.montant,
            prixBrut: prixBrutProduit,
            tlpe: 0,
            honoraires: 0,
            fraisTechnique: 0,
            isEcheancierFictif: isEcheancierFictif,
            isNonRenouvelee: isNonRenouvelee,
          };
          if (echeanciers[dates]) {
            if (echeanciers[dates].tlpe) echeancierLigne.tlpe = echeanciers[dates].tlpe;
            if (echeanciers[dates].honoraires) {
              echeancierLigne.honoraires = echeanciers[dates].honoraires;
            }
            if (echeanciers[dates].fraisTechnique) {
              echeancierLigne.fraisTechnique = echeanciers[dates].fraisTechnique;
            }
          }
          echeanciers[dates] = echeancierLigne;
        });
      }
    }
    if (ligneCommande.libelle.toLowerCase().includes('tlpe')) {
      if (echeancier) {
        echeancier.echeancierLignes.forEach((ech) => {
          getEcheanchier(
            ['prixNet', 'prixBrut', 'honoraires', 'fraisTechnique'],
            'tlpe',
            ech,
            echeanciers,
          );
        });
      }
    }
    if (ligneCommande.libelle.toLowerCase().includes('honoraires')) {
      if (echeancier) {
        const isEcheancierFictif = echeancier.id === '00000000-0000-0000-0000-000000000000';
        echeancier.isEcheancierFictif = isEcheancierFictif;
        echeancier.echeancierLignes.forEach((ech) => {
          getEcheanchier(
            ['prixNet', 'prixBrut', 'tlpe', 'fraisTechnique'],
            'honoraires',
            ech,
            echeanciers,
          );
        });
      }
    }
    if (ligneCommande.libelle.toLowerCase().includes('frais')) {
      if (echeancier) {
        echeancier.echeancierLignes.forEach((ech) => {
          getEcheanchier(
            ['prixNet', 'prixBrut', 'tlpe', 'honoraires'],
            'fraisTechnique',
            ech,
            echeanciers,
          );
        });
      }
    }
  });
  // régrouper les échéancier par an
  const echeanciersRegroupeParAn = {};
  Object.values(echeanciers).forEach(ech => {
    const annee = `${moment(ech.dateDebut).format('YYYY')}`;
    if (echeanciersRegroupeParAn[annee]) {
      echeanciersRegroupeParAn[annee].prixNet += ech.prixNet;
      echeanciersRegroupeParAn[annee].prixBrut += ech.prixBrut;
      echeanciersRegroupeParAn[annee].tlpe += ech.tlpe;
      echeanciersRegroupeParAn[annee].honoraires += ech.honoraires;
      echeanciersRegroupeParAn[annee].fraisTechnique += ech.fraisTechnique;
      echeanciersRegroupeParAn[annee].isEcheancierFictif = ech.isEcheancierFictif;
      echeanciersRegroupeParAn[annee].isNonRenouvelee = ech.isNonRenouvelee;
      if (moment(echeanciersRegroupeParAn[annee].dateDebut).isAfter(ech.dateDebut)) {
        echeanciersRegroupeParAn[annee].dateDebut = ech.dateDebut;
      }
      if (moment(echeanciersRegroupeParAn[annee].dateFin).isBefore(ech.dateFin)) {
        echeanciersRegroupeParAn[annee].dateFin = ech.dateFin;
      }
    } else echeanciersRegroupeParAn[annee] = ech;
  });
  return {
    codeFace: ligne.produit.produitFace.codeFace,
    urlProduit: ligne.cheminProduit,
    format: ligne.produit.produitFace.format
      ? ligne.produit.produitFace.format
      : '',
    materiel: ligne.produit.produitFace.materielType
      ? ligne.produit.produitFace.materielType
      : '',
    regie: ligne.produit.tiers ? ligne.produit.tiers.nomCommercial : '',
    adresse: adressFullStringGetter(ligne.produit.produitFace.adresse),
    tiersId: ligne.devisCommande.intervenants.map((el) => el.tiersId),
    azimut: ligne.produit.produitFace.azimut
      ? ligne.produit.produitFace.azimut
      : 0,
    coordonnees: {
      lat: ligne.produit.produitFace.adresse.latitude
        ? ligne.produit.produitFace.adresse.latitude
        : 0,
      lng: ligne.produit.produitFace.adresse.longitude
        ? ligne.produit.produitFace.adresse.longitude
        : 0,
    },
    libelle: ligne.produit.libelle,
    dateDebut: ligne.dateDebut,
    dateFin: ligne.dateFin,
    total: ligne.totalHt,
    couleur,
    categorie,
    prixBrutProduit,
    echeanciers: Object.values(echeanciersRegroupeParAn),
    commercial: ligne.commercial,
    produitPatrimoine: true,
    id: ligne.produit.id,
    isNonRenouvelee,
  };
}

export function limitProduits(produits, tiersId) {
  return produits.filter(produit => produit.tiersId.some(id => tiersId.includes(id)));
}

export function formatFace(ligne, index) {
  const societe = store.getters['dataTiers/societe'];
  let couleur = '';
  let categorie = '';
  let prixBrutProduit = 0;
  let dateDebut = null;
  let dateFin = null;
  const echeanciers = {};
  const isNonRenouvelee = ligne.lignesCommande
    && ligne.lignesCommande.some(lc => lc.isNonRenouvelee === true);
  const existeEcheancierFictif = ligne.lignesCommande.some(lc => lc.echeanciers.some(e => e.id === '00000000-0000-0000-0000-000000000000'));
  const existeEcheancierNonFictif = ligne.lignesCommande.some(lc => lc.echeanciers.some(e => e.id !== '00000000-0000-0000-0000-000000000000'));

  ligne.lignesCommande.forEach((ligneCommande) => {
    const echeancier = ligneCommande.echeanciers.find(
      (el) => el.referenceEcheancier === ligneCommande.referenceEcheancier,
    );

    if (ligneCommande.libelle.toLowerCase().includes('location') || ligneCommande.typeProduit === 'Location') {
      const libelle = ligneCommande.libelle.replace('Location', '').trim();
      couleur = getCouleurCategorie(libelle);
      categorie = libelle || CATEGORIE_DEFAULT;
      if (echeancier) {
        const isEcheancierFictif = echeancier.id === '00000000-0000-0000-0000-000000000000';

        const existeAuMoinsUn = existeEcheancierFictif || existeEcheancierNonFictif;
        const casInterdit = existeEcheancierFictif && existeEcheancierNonFictif
        && isEcheancierFictif;

        if (existeAuMoinsUn && !casInterdit) {
          dateDebut = ligneCommande.dateDebut;
          dateFin = ligneCommande.dateFin;
        }
        echeancier.isEcheancierFictif = isEcheancierFictif;
        echeancier.echeancierLignes.forEach((ech) => {
          let newDateFin = ech.dateFin;
          if (echeancier.quantitePeriodicite === 0) {
            newDateFin = ligneCommande.dateFin;
          }
          const dates = `${moment(ech.dateDebut).format('DDMMYYYY')}_${moment(
            newDateFin,
          ).format('DDMMYYYY')}`;
          prixBrutProduit = ligneCommande.prixUnitaire;
          const echeancierLigne = {
            dateDebut: ech.dateDebut,
            dateFin: newDateFin,
            prixNet: ech.montant,
            prixBrut: prixBrutProduit,
            tlpe: 0,
            honoraires: 0,
            fraisTechnique: 0,
            isEcheancierFictif: isEcheancierFictif,
            isNonRenouvelee: isNonRenouvelee,
          };
          if (echeanciers[dates]) {
            if (echeanciers[dates].tlpe) echeancierLigne.tlpe = echeanciers[dates].tlpe;
            if (echeanciers[dates].honoraires) {
              echeancierLigne.honoraires = echeanciers[dates].honoraires;
            }
            if (echeanciers[dates].fraisTechnique) {
              echeancierLigne.fraisTechnique = echeanciers[dates].fraisTechnique;
            }
          }
          echeanciers[dates] = echeancierLigne;
        });
      }
    }
    if (ligneCommande.libelle.toLowerCase().includes('tlpe')) {
      if (echeancier) {
        echeancier.echeancierLignes.forEach((ech) => {
          getEcheanchier(
            ['prixNet', 'prixBrut', 'honoraires', 'fraisTechnique'],
            'tlpe',
            ech,
            echeanciers,
          );
        });
      }
    }
    if (ligneCommande.libelle.toLowerCase().includes('honoraires')) {
      if (echeancier) {
        const isEcheancierFictif = echeancier.id === '00000000-0000-0000-0000-000000000000';
        echeancier.isEcheancierFictif = isEcheancierFictif;
        echeancier.echeancierLignes.forEach((ech) => {
          getEcheanchier(
            ['prixNet', 'prixBrut', 'tlpe', 'fraisTechnique'],
            'honoraires',
            ech,
            echeanciers,
          );
        });
      }
    }
    if (ligneCommande.libelle.toLowerCase().includes('frais')) {
      if (echeancier) {
        echeancier.echeancierLignes.forEach((ech) => {
          getEcheanchier(
            ['prixNet', 'prixBrut', 'tlpe', 'honoraires'],
            'fraisTechnique',
            ech,
            echeanciers,
          );
        });
      }
    }
  });

  // régrouper les échéancier par an
  const echeanciersRegroupeParAn = {};
  Object.values(echeanciers).forEach(ech => {
    const annee = `${moment(ech.dateDebut).format('YYYY')}`;
    if (echeanciersRegroupeParAn[annee]) {
      echeanciersRegroupeParAn[annee].prixNet += ech.prixNet;
      echeanciersRegroupeParAn[annee].prixBrut += ech.prixBrut;
      echeanciersRegroupeParAn[annee].tlpe += ech.tlpe;
      echeanciersRegroupeParAn[annee].honoraires += ech.honoraires;
      echeanciersRegroupeParAn[annee].fraisTechnique += ech.fraisTechnique;
      echeanciersRegroupeParAn[annee].isEcheancierFictif = ech.isEcheancierFictif;
      echeanciersRegroupeParAn[annee].isNonRenouvelee = ech.isNonRenouvelee;
      if (moment(echeanciersRegroupeParAn[annee].dateDebut).isAfter(ech.dateDebut)) {
        echeanciersRegroupeParAn[annee].dateDebut = ech.dateDebut;
      }
      if (moment(echeanciersRegroupeParAn[annee].dateFin).isBefore(ech.dateFin)) {
        echeanciersRegroupeParAn[annee].dateFin = ech.dateFin;
      }
    } else echeanciersRegroupeParAn[annee] = ech;
  });
  return {
    codeFace: ligne.produit.produitFace.codeFace,
    urlProduit: ligne.cheminProduit,
    format: ligne.produit.produitFace.format
      ? ligne.produit.produitFace.format
      : '',
    materiel: ligne.produit.produitFace.materielType
      ? ligne.produit.produitFace.materielType
      : '',
    regie: ligne.produit.tiers ? ligne.produit.tiers.nomCommercial : '',
    adresse: adressFullStringGetter(ligne.produit.produitFace.adresse),
    azimut: ligne.produit.produitFace.azimut
      ? ligne.produit.produitFace.azimut
      : 0,
    coordonnees: {
      lat: ligne.produit.produitFace.adresse.latitude
        ? ligne.produit.produitFace.adresse.latitude
        : 0,
      lng: ligne.produit.produitFace.adresse.longitude
        ? ligne.produit.produitFace.adresse.longitude
        : 0,
    },
    libelle: ligne.produit.libelle,
    dateDebut,
    dateFin,
    total: ligne.totalHt,
    couleur,
    categorie,
    prixBrutProduit,
    echeanciers: Object.values(echeanciersRegroupeParAn),
    commercial: ligne.lignesCommande[0].commercial,
    id: ligne.produit.id,
    num: index ? index + 1 : 1,
    societeLibelle: societe.libelle,
    isNonRenouvelee,
  };
}
